import { render, staticRenderFns } from "./Rozliczenia.vue?vue&type=template&id=0021a392&scoped=true&"
import script from "./Rozliczenia.vue?vue&type=script&lang=js&"
export * from "./Rozliczenia.vue?vue&type=script&lang=js&"
import style0 from "./Rozliczenia.vue?vue&type=style&index=0&id=0021a392&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0021a392",
  null
  
)

export default component.exports